export const RESET_COMPANY_AUTHENTICATION_OPEN_MODAL = "RESET_COMPANY_AUTHENTICATION_OPEN_MODAL";
export const RESET_COMPANY_AUTHENTICATION_CLOSE_MODAL = "RESET_COMPANY_AUTHENTICATION_CLOSE_MODAL";

export const RESET_COMPANY_AUTHENTICATION_REQUEST = "RESET_COMPANY_AUTHENTICATION_REQUEST";
export const RESET_COMPANY_AUTHENTICATION_RESULT = "RESET_COMPANY_AUTHENTICATION_RESULT";